import React from 'react';
import { PropTypes } from 'prop-types';
import { isEmpty } from 'lodash';
import { CardDetail } from 'src/common/Card';

const ProviderDetails = ({
  invoice,
  providerAddress,
}) => (
  <>
    <CardDetail label="Name">{invoice.provider_name}</CardDetail>
    <CardDetail label="Address">
      { !isEmpty(providerAddress) && (
        <>
          <div>{providerAddress.line_1}</div>
          <div>{providerAddress.line_2}</div>
          <div>{providerAddress.city}, {providerAddress.state} {providerAddress.postal_code}</div>
        </>
      )}
    </CardDetail>
  </>
);

ProviderDetails.propTypes = {
  invoice: PropTypes.object.isRequired,
  providerAddress: PropTypes.object,
};

ProviderDetails.defaultProps = {
  providerAddress: {},
};

export default ProviderDetails;
